module.exports = __webpack_public_path__ + "img/kh5.89552163.png";